import { eLayoutType, RoutesService } from '@abp/ng.core';
import { APP_INITIALIZER } from '@angular/core';

export const LOCATIONS_LOCATION_ROUTE_PROVIDER = [
  { provide: APP_INITIALIZER, useFactory: configureRoutes, deps: [RoutesService], multi: true },
];

function configureRoutes(routes: RoutesService) {
  return () => {
    routes.add([
      {
        path: '/locations',
        iconClass: 'fas fa-map-pin',
        name: 'RegisterService::Menu:Locations',
        parentName: 'RegisterService::Menu:RegisterService',
        order: 29,
        layout: eLayoutType.application,
        requiredPolicy: 'RegisterService.Locations.Page',
      },
    ]);
  };
}
